module.exports = __webpack_public_path__ + "static/media/3.44f25cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/3.png
// module id = 1199
// module chunks = 0